import { AppThunk } from 'redux/reducers/rootReducer';
import { ITableData } from 'types/backend_models/shared/ITableData';
import { IDocument } from 'types/backend_models/documents/IDocument';
import { IGenericDataFetchParams, createGenericDataFetch } from '../generic/GenericDataActions';
import { initialState, setFetchInvoiceDocumentsPending, setFetchInvoiceDocumentsSucces, setFetchInvoiceDocumentsError } from 'redux/reducers/data_action_reducers/invoices/InvoiceDocumentsReducer';

const defaultQueryData = {
	sorted: '',
	filters: [],
	currentPage: initialState.data.currentPage,
	pageSize: initialState.data.pageSize
}

// Salesinvoices owner type id
const docOwnerTypeId = 8;

var fetchParams: IGenericDataFetchParams<ITableData<IDocument[]>> = {
	apiEndPoint: '',
	pendingActionCreator: setFetchInvoiceDocumentsPending,
	succesActionCreator: setFetchInvoiceDocumentsSucces,
	errorActionCreator: setFetchInvoiceDocumentsError,
	logResult: false
}

export function fetchInvoiceDocuments(invoiceId: number): AppThunk
{
	let filters = `documentownertypeid==${docOwnerTypeId}, documentownerid==${invoiceId}`;
	const query = `?Page=${defaultQueryData.currentPage}&PageSize=${defaultQueryData.pageSize}&filters=${filters}`;
	fetchParams.apiEndPoint = `customer/documents${query}`;

	return createGenericDataFetch<ITableData<IDocument[]>>(fetchParams);
}